/* 专家端专属 mutation type */

export const AJAX_GET_MESSAGES = 'AJAX_GET_MESSAGES'; // 主动拉取消息
export const AJAX_GET_COURSELIST = 'AJAX_GET_COURSELIST'; // 获取专家课程列表
export const AJAX_GET_COURSEINFO = 'AJAX_GET_COURSEINFO'; // 获取专家课程详情
export const AJAX_GET_COURSE_RECOMMEND = 'AJAX_GET_COURSE_RECOMMEND';     // 更多推荐课程接口
export const AJAX_GET_MATERIAL_PICTURELIST = 'AJAX_GET_MATERIAL_PICTURELIST'; // 获取专家素材库图片列表
export const AJAX_GET_MATERIAL_AUDIOLIST = 'AJAX_GET_MATERIAL_AUDIOLIST'; // 获取专家素材库音频列表
export const AJAX_GET_MATERIAL_VIDEOLIST = 'AJAX_GET_MATERIAL_VIDEOLIST'; // 获取专家素材库视频列表
export const AJAX_GET_MATERIAL_PPTLIST = 'AJAX_GET_MATERIAL_PPTLIST'; // 获取专家素材库PPT列表
export const CLEAR_MATERIALLIST_LOCAL = 'CLEAR_MATERIALLIST_LOCAL'; // 清空专家素材库图片/音频列表
export const AJAX_WX_STARTRECORD = 'AJAX_WX_STARTRECORD'; // 开始录音
export const AJAX_WX_STOPRECORD = 'AJAX_WX_STOPRECORD'; // 停止录音
export const AJAX_WX_UPDATERECORD = 'AJAX_WX_UPDATERECORD'; // 更新音频文件
export const AJAX_WX_RERECORD = 'AJAX_WX_RERECORD'; // 重新录音
export const AJAX_WX_ONVOICERECORDEND = 'AJAX_WX_ONVOICERECORDEND'; // 监听录音自动停止接口
export const AJAX_WX_UPLOADVOICE = 'AJAX_WX_UPLOADVOICE'; // 上传语音接口
export const AJAX_WX_UPLOADRECORD = 'AJAX_WX_UPLOADRECORD'; // 语音正在上传中
export const AJAX_WX_GETNETWORKTYPE = 'AJAX_WX_GETNETWORKTYPE'; // 获取网络状态接口
export const AJAX_WX_CHOOSEIMAGE = 'AJAX_WX_CHOOSEIMAGE'; // 选择图片
export const AJAX_WX_CHOOSESENDIMAGE = 'AJAX_WX_CHOOSESENDIMAGE'; // 选择要发送图片
export const AJAX_WX_UPLOADIMAGE = 'AJAX_WX_UPLOADIMAGE'; // 上传图片
export const DELETEIMAGEONLOCAL = 'DELETEIMAGEONLOCAL'; // 将图片从本地状态移除
export const AJAX_GET_EXPERTAUTH = 'AJAX_GET_EXPERTAUTH'; // 专家授权
export const AJAX_GET_ISSUES = 'AJAX_GET_ISSUES'; // 获取问题列表
export const AJAX_GET_SLIDES = 'AJAX_GET_SLIDES'; // 获取问题列表
export const AJAX_GET_COURSE_MSG_LIST = 'AJAX_GET_COURSE_MSG_LIST'; // 获取课程留言列表
export const AJAX_GET_GUESTBOOK_LIST = 'AJAX_GET_GUESTBOOK_LIST'; // 获取课程留言版列表
export const ADD_REPLY_TO_LIST = 'ADD_REPLY_TO_LIST'; // 获取课程留言版列表
export const DEL_REPLY_TO_LIST = 'DEL_REPLY_TO_LIST'; // 删除课程留言版列表

// 组件
export const COMPONENTS_CURRENTMESSAGE = 'COMPONENTS_CURRENTMESSAGE'; // 当前消息

export const COMPONENTS_POPUPVISIBLE = 'COMPONENTS_POPUPVISIBLE'; // 直播中的素材管理窗体是否显示

export const COMPONENTS_LIVEBARACTIVE = 'COMPONENTS_LIVEBARACTIVE'; // 消息编辑选项卡

export const STATE_ONLYSELF = 'STATE_ONLYSELF'; // 只看自己状态

export const UPDATE_MESSAGE_REF_STATUS = 'UPDATE_MESSAGE_REF_STATUS'; // 更新消息回复状态

export const LOOK_HISTORY_MESSAGE = 'LOOK_HISTORY_MESSAGE'; // 触发更新查看历史消息状态
export const GET_MEDIAID = 'GET_MEDIAID'; // 获取音频服务端id
export const AJAX_GET_IMMESGINFO = 'AJAX_GET_IMMESGINFO';  // 已完成订单im消息




// WEBPACK FOOTER //
// ./src/store/expert/mutation-types.expert.js